import { computed, type ComputedRef } from 'vue';
import { useProduct } from '~/modules/product/composables/useProduct';
import { GIFT_CARD_TYPE } from '../constants/giftcard';
import type { GIFT_CARD_PAYLOAD, GIFT_CARD_FIELDS } from '../types';

/**
 * * ATB Gift Card Payload
 */
export const useGiftPayload = (values: Partial<Record<GIFT_CARD_FIELDS, string>>, giftCardType: GIFT_CARD_TYPE): ComputedRef<GIFT_CARD_PAYLOAD> => {
  const { productData } = useProduct();
  const payload = { productType: productData?.detail.typeName };

  return computed(() => {
    if (giftCardType === GIFT_CARD_TYPE.CONSOLIDATED_MASTER) {
      return payload;
    }
    return {
      ...payload,
      ...values,
      isEGiftCard: giftCardType === GIFT_CARD_TYPE.E_GIFT_CARD,
    };
  });
};
